const values = [
  {
    title: 'Compassion',
    icon: 'ri-heart-line',
    description: 'We lead with empathy, respect, and kindness, recognizing the unique experiences, strengths, and potential of every individual.',
  },
  {
    title: 'Excellence',
    icon: 'ri-star-line',
    description: 'We are committed to delivering exceptional care through professionalism, continuous learning, and the highest standards of service.',
  },
  {
    title: 'Integrity',
    icon: 'ri-shield-check-line',
    description: 'We act with honesty, transparency, and accountability, building trust with the individuals we support, our partners, and our communities.',
  },
  {
    title: 'Collaboration',
    icon: 'ri-team-line',
    description: 'We believe the best outcomes are achieved by working together with individuals, families, agencies, healthcare professionals, and community partners.',
  },
  {
    title: 'Person-Centred Care',
    icon: 'ri-user-heart-line',
    description: 'Every individual is unique. We tailor our services to each person\'s goals, strengths, preferences, and support needs.',
  },
  {
    title: 'Empowerment',
    icon: 'ri-sun-line',
    description: 'We help individuals develop the confidence, skills, and opportunities to live as independently and successfully as possible.',
  },
  {
    title: 'Inclusion',
    icon: 'ri-hand-heart-line',
    description: 'We foster welcoming environments where diversity is valued, every voice is respected, and everyone has the opportunity to belong and thrive.',
  },
  {
    title: 'Innovation',
    icon: 'ri-lightbulb-line',
    description: 'We embrace new ideas, evidence-informed practices, and creative solutions to continually improve the quality of our services and the outcomes we achieve.',
  },
];

export default function MissionValuesSection() {
  return (
    <section className="py-20 md:py-28 bg-background-50">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        {/* Mission & Vision */}
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-8 lg:gap-12 mb-20">
          <div className="bg-background-100 rounded-2xl p-8 md:p-10 border border-background-200/70">
            <span className="inline-block bg-primary-100 text-primary-700 text-xs font-semibold px-4 py-1.5 rounded-full uppercase tracking-wider label-font mb-5">
              Our Mission
            </span>
            <p className="heading-font text-2xl md:text-3xl font-bold text-foreground-900 leading-snug">
              To empower individuals through compassionate care, meaningful support, and opportunities to thrive.
            </p>
          </div>

          <div className="bg-background-100 rounded-2xl p-8 md:p-10 border border-background-200/70">
            <span className="inline-block bg-accent-100 text-accent-800 text-xs font-semibold px-4 py-1.5 rounded-full uppercase tracking-wider label-font mb-5">
              Our Vision
            </span>
            <p className="heading-font text-2xl md:text-3xl font-bold text-foreground-900 leading-snug">
              To be the most trusted residential service provider, transforming lives through exceptional care, strong partnerships, and lasting outcomes.
            </p>
          </div>
        </div>

        {/* Values */}
        <div className="mb-14">
          <span className="inline-block bg-secondary-100 text-secondary-800 text-xs font-semibold px-4 py-1.5 rounded-full uppercase tracking-wider label-font mb-4">
            Our Values
          </span>
          <h2 className="heading-font text-3xl md:text-5xl font-bold text-foreground-900 max-w-2xl leading-tight">
            The principles that <span className="italic text-primary-600">guide</span> everything we do.
          </h2>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-5">
          {values.map((value) => (
            <div
              key={value.title}
              className="bg-background-100 rounded-xl p-6 border border-background-200/70 hover:border-primary-200 transition-all duration-300 group cursor-default"
            >
              <span className="w-10 h-10 flex items-center justify-center rounded-lg bg-accent-100 text-accent-700 mb-4 group-hover:bg-accent-200 transition-colors">
                <i className={`${value.icon} text-lg`}></i>
              </span>
              <h3 className="heading-font text-lg font-bold text-foreground-900 mb-2">{value.title}</h3>
              <p className="text-foreground-600 text-sm leading-relaxed">{value.description}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}